import { connect } from 'formik'
import LogErrors from './LogErrors'

export default connect(LogErrors)
